export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SmallVideoList.vue?vue&type=template&id=3cf84b98&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/SmallVideoList.vue?vue&type=template&id=3cf84b98&scoped=true&
// module id = null
// module chunks = 